export default __webpack_public_path__ + "static/media/shaban_1.21d1e74f.jpg";